import { HeaderTabsProps } from '@app/components/common/HeaderTabs';

export const SETTINGS_TABS: HeaderTabsProps['tabs'] = {
    PASSWORD: {
        name: 'password',
        title: 'userSettings.tabs.password',
        permission: null,
        dataTest: 'password-tab',
        iconDef: 'fa-regular fa-lock-keyhole',
    },
    DEFAULT_FILTERS: {
        name: 'default-filter',
        title: 'userSettings.tabs.defaultFilters',
        permission: null,
        dataTest: 'default-filters-tab',
        iconDef: 'fa-solid fa-sliders',
    },
    REGION: {
        name: 'csv-delimiter',
        title: 'userSettings.tabs.region',
        permission: null,
        dataTest: 'region-tab',
        iconDef: 'fa-solid fa-globe',
    },
};
